<div mat-dialog-content>
  <h2>Statut des besoins (de la livraison)</h2>
  <p>
    <span class="state-circle state-circle-AS"></span>
    <b>A saisir :</b> les inventaires ont été pré-initialisés par lingerie pour vos livraisons des 2 prochaines
    semaines, vous devez indiquer les quantités restantes par articles.
  </p>

  <p>
    <span class="state-circle state-circle-EA"></span>
    <b>En attente :</b> des quantités ont été renseignées et enregistrées mais les inventaires n'ont pas été validés.
  </p>

  <p>
    <span class="state-circle state-circle-V"></span>
    <b>Validé :</b> les inventaires ont été validés, ils ne sont plus modifiables.
  </p>

  <p>
    <span class="state-circle state-circle-C"></span>
    <b>Complet :</b> la livraison est conforme à votre besoin.
  </p>

  <p>
    <span class="state-circle state-circle-AD"></span>
    <b>A dispatcher :</b> la livraison n'est pas conforme à votre besoin et à besoin d'être dispatchée.
  </p>

  <p>
    <span class="state-circle state-circle-V"></span>
    <b>Dispatché :</b> la livraison a été dispatchée.
  </p>

  <h2>Statut des inventaires</h2>
  <p>
    <span class="state-circle state-circle-AS"></span>
    <b>A saisir :</b> l'inventaire est pré-initialisé par lingerie, vous devez renseigner la colonne « restant » par
    articles.
  </p>

  <p>
    <span class="state-circle state-circle-EC"></span>
    <b>En cours :</b> tous les articles n'ont pas de quantité restante de renseignée.
  </p>

  <p>
    <span class="state-circle state-circle-R"></span>
    <b>Renseigné :</b> toutes les quantités restantes sont renseignées, mais l'inventaire n'est pas validé.
  </p>

  <p>
    <span class="state-circle state-circle-V"></span>
    <b>Validé :</b> l'inventaire a été validé, il n'est plus modifiable.
  </p>
</div>
<div class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Retour</button>
</div>